import 'react-bootstrap-tagsinput/dist/index.css'
import {Suspense, useEffect, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {useDispatch, useSelector} from 'react-redux'
import {
  getAllUserDetails,
  getSoundNotificationSetting,
} from './pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import './app.css'
import {getUserData} from './modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {io} from 'socket.io-client'
import {ContactClosePopup, ContactStartUpload} from './Components/PopupSlice/popupSlice'
import {systemNotification, portalNotification} from './Redux/NotificationSlice/NotificationSlice'
import {ENV} from './Utils/_helpers/EnvHelper'
import '@stripe/stripe-js'
import 'react-circular-progressbar/dist/styles.css'
import moment from 'moment'
import 'moment-timezone'
import {MsalProvider} from '@azure/msal-react'
import {GoogleOAuthProvider} from '@react-oauth/google'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'
import {useLazyGetGroupQuery} from '../services/cellcast'
import {useTawkToController} from './hooks/useTawkToController'
import {InboxSmsBadge, ConversationBadge} from './pages/UserPages/inbox-v2/InboxSlice/InboxSlice'


const App = ({pca}: any) => {
  const dispatch = useDispatch()
  const sys = useSelector((state: any) => state?.notification?.system)
  const port = useSelector((state: any) => state?.notification?.portal)
  const userData = useSelector(getAllUserDetails)
  const data = userData?.timeZone
  const isNewInboxEnabled = userData?.globalSetting?.includes('newInbox')
  const isAdmin = localStorage.getItem('isAdmin') === 'true'

  console.log('User data from Redux:', isAdmin)
  const ENDPOINT: any = ENV().REACT_APP_DOMAIN_SOCKETID
  const TAWK_TO_PROPERTY_ID = ENV().REACT_APP_TAWK_TO_PROPERTY_ID
  const TAWK_TO_WIDGET_ID = ENV().REACT_APP_TAWK_TO_WIDGET_ID
  const user = useSelector(getUserData)
  const soundSetting = useSelector(getSoundNotificationSetting)
  const Admin = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user)
  const [socket, setSocket] = useState<any>(null)
  const [getGroup] = useLazyGetGroupQuery()


  useEffect(() => {
    // Create the socket instance
    if (user?.user?._id !== undefined || Admin?._id !== undefined) {
      const newSocket = io(ENDPOINT, {
        transports: ['polling'],
        query: {
          userId: user?.user?._id || Admin?._id,
        },
      })

      // Set the socket instance in the state
      setSocket(newSocket)
    }

    // Clean up the socket on component unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.user?._id, Admin?._id])

  socket?.on('notification', (data: any) => {
    const playNotificationSound = () => {
      const audio = new Audio('/sounds/new-notification-cellcast.mp3')
      audio.play().catch(err => console.warn('Audio playback failed:', err))
    }
    if (
      data?.type === 'system' &&
      sys?.find((key: any) => key?._id === data?._id)?._id === undefined
    ) {
      dispatch(systemNotification([...sys, data]))
    }
    if (
      data?.type === 'inbox' &&
      port?.find((key: any) => key?._id === data?._id)?._id === undefined
    ) {
      dispatch(portalNotification([...port, data]))
    }

    if (['inbox', 'system'].includes(data?.type)) {
      if (soundSetting?.newNotification === true) {
        playNotificationSound()
      }
    }

    if (data?.type === 'new_inbox') {
      // Only call inbox badge for non-admin users
      if (!isAdmin) {
        // Use conversation badge when new inbox is enabled, otherwise use legacy inbox badge
        if (isNewInboxEnabled) {
          dispatch(ConversationBadge())
        } else {
          dispatch(InboxSmsBadge())
        }
      }
      if (soundSetting?.newInbox === true) {
        playNotificationSound()
      }
    }
    
    if (data?.type === 'contact_upload') {
      dispatch(ContactClosePopup())
      dispatch(ContactStartUpload())
      dispatch(portalNotification([...port, data]))
      getGroup(null)
    }
  })
  useEffect(() => {
    var numberInputs = document.querySelectorAll('input[type="number"]')
    // Attach a 'mousewheel' event listener to each input element
    numberInputs.forEach(function (input: any) {
      input.addEventListener('mousewheel', (e: any) => {
        // Remove focus from the input element
        input.blur()
      })
    })
  }, [])

  useEffect(() => {
    if (data && data.length > 0) {
      moment.tz.setDefault(data)
    }
  }, [data])

  // let timeZone = data && moment.tz.setDefault(data)
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <MsalProvider instance={pca}>
        <GoogleOAuthProvider clientId={ENV().REACT_APP_GOOGLE_CLIENT_ID || ''}>
          <I18nProvider>
            <LayoutProvider>
              <ToastContainer autoClose={3000} />
              <Outlet />
              <MasterInit />
              {/* TODO: Enable later
              <TawkMessengerReact
                ref={tawkMessengerReactRef}
                onLoad={handleLoad}
                propertyId={TAWK_TO_PROPERTY_ID}
                widgetId={TAWK_TO_WIDGET_ID}/>               */}
            </LayoutProvider>
          </I18nProvider>
        </GoogleOAuthProvider>
      </MsalProvider>
    </Suspense>
  )
}

export {App}
